import fetchVendors from 'app/apis/fetchVendors'
import ToastAndroid from 'app/mocks/ToastAndroid'
import { VendorRequest } from 'app/models/RequestFlow'
import { fixNextPageUrl } from 'app/utils/helpers/fixNextPageUrl'
import { useCallback, useEffect, useState } from 'react'
import { get } from 'app/utils/axios/kheti'
import ApiResponse from 'app/models/apiResponse'

type FetchVendorParams = {
  category?: string
  node_id?: number[]
  state_id?: number[]
  search_query?: string
  role_type?: string
  lang?: string
}

const useFetchVendors = ({
  category,
  node_id,
  state_id,
  search_query,
  role_type,
  lang = 'en',
}: FetchVendorParams) => {
  const [request, setRequest] = useState<VendorRequest[]>([])
  const [recentVendors, setRecentVendors] = useState<VendorRequest[]>([])
  const [loading, setLoading] = useState(false)
  const [loadingNext, setLoadingNext] = useState(false)
  const [page, setPage] = useState(1)
  const [nextPageUrl, setNextPageUrl] = useState<string | null>('')

  const fetchNext = useCallback(async () => {
    if (nextPageUrl) {
      try {
        setLoadingNext(true)
        const response = await get<ApiResponse<VendorRequest>>(nextPageUrl)
        if (response) {
          setRequest(prev => prev.concat(response.results))
          setPage(prev => prev + 1)
          setNextPageUrl(fixNextPageUrl(response.next) || null)
        }
      } catch (e) {
        ToastAndroid.show('Something went wrong', ToastAndroid.SHORT)
      } finally {
        setLoadingNext(false)
      }
    }
  }, [nextPageUrl])

  const getRequest = useCallback(async () => {
    setLoading(true)
    try {
      const stateIds = state_id?.map((s: any) => s.id) || []
      const nodeIds = node_id?.map((n: any) => n.id) || []

      const response = await fetchVendors(
        1,
        category,
        nodeIds,
        stateIds,
        search_query,
        role_type
      )

      if (response) {
        setRequest(response.results || [])
        setRecentVendors(response.recent_vendors || [])
        setNextPageUrl(fixNextPageUrl(response.next) || null)
        setPage(1)
      }
    } catch (e) {
      ToastAndroid.show('Something went wrong', ToastAndroid.SHORT)
    } finally {
      setLoading(false)
    }
  }, [category, node_id, state_id, search_query, lang,role_type])

  useEffect(() => {
    getRequest()
  }, [getRequest])

  return {
    fetchNext,
    request,
    recentVendors,
    loading,
    loadingNext,
  }
}

export default useFetchVendors
